import { CalloutSkin, CalloutTagType, CalloutVariant, CalloutEmphasis } from '../../../types/Callout'
import { reviewData } from '../../../types/Contentful/ContentfulTypes'

export interface AutomatedExperience {
  pageTitle: string
  pageSubtitle: string
  merchandisingCategoryId: string
  sections: AutomatedSections[]
}

export interface ColorSwatch {
  merchandisingName: string
  key: string
  outOfStock?: boolean
}
export interface ColorInformation {
  colorSwatches: ColorSwatch[]
}

export enum CalloutType {
  TAG = 'TAG',
  CAMPAIGN = 'CAMPAIGN',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}
export interface ProductCallout {
  value?: string
  skin?: CalloutSkin
  variant?: CalloutVariant
  emphasis?: CalloutEmphasis
  tagType?: CalloutTagType
  type?: CalloutType
}
export interface ProductImage {
  src: string
  altTextOverride: string
}

export interface ProductVariants {
  quantity: string
  variants: Record<string, string>
}
export interface SectionProductItem {
  mpvId: string
  productId: string
  version: number
  selectedProductVariants: Record<string, any>
  name: string
  description: string
  image: ProductImage
  linkUrl: string
  callout?: ProductCallout[]
  isOutOfStock: boolean
  colorInformation: ColorInformation
  review?: reviewData
}

export interface SectionHeader {
  title: string
  subtitle: string
}

export interface AutomatedSections {
  type: string
  header: SectionHeader
  specificLocales: string[]
  sectionId: string
  itemsType: string
  items: SectionProductItem[]
}
